import { APIError, AppError, HttpMethod } from 'types';

export enum ContentTypes {
  Json = 'application/json',
  domainModelSaveJson = 'application/json;domain-model=savediscountorcharge',
  domainModelUpdateJson = 'application/json;domain-model=activatediscountorcharge',
  PatchJson = 'application/json-patch+json',
  PDF = 'application/pdf',
  Apk = 'application/vnd.android.package-archive'
}

export const ORDER_MODIFICATION_GUARD_ACTIONS = [
  'om:cancelOrder',
  'om:updateTimeslot',
  'om:reReserveTimeslot',
  'om:fulfillConsignment',
  'of:cancelOrder',
  'of:readyForPicking',
  'of:startManualPicking',
  'of:singlePick',
  'of:multiPick',
  'of:updateFulfillmentTime',
] as const;

export type OrderModificationGuardAction = (typeof ORDER_MODIFICATION_GUARD_ACTIONS)[number];

export const ORDER_FLAG_SOURCE_ACTIONS = [
  'om:orderList',
  'om:orderDetail',
  'of:orderList',
  'of:orderDetail',
] as const;

export type OrderFlagSourceAction = (typeof ORDER_FLAG_SOURCE_ACTIONS)[number];

export type RequestTag = OrderModificationGuardAction | OrderFlagSourceAction;

export interface IFetchDataRequest<E = any> {
  /**
   * Full url
   */
  url: string;
  /**
   * Default: GET
   */
  method?: HttpMethod;
  body?: any;
  /**
   * query string parameters
   */
  query?: object;
  /**
   * When this value is set, fetchData will return the content in /public/__mocks__/${mock}.json file
   */
  mock?: string;
  /**
   * For requests that require "If-Match" header
   */
  eTag?: string;
  /**
   * @param rawResponse api raw error response to be mapped
   */
  mapErrors?: (rawResponse: any) => AppError<E>;
  /**
   * For setting specific content in the request
   */
  contentType?: ContentTypes;
  headers?: { [k: string]: string };
  skipInterceptors?: boolean;
  /**
   * Semantic label identifying what operation this request represents.
   * Used by cross-cutting interceptors (e.g. modification guard) to match
   * requests without URL parsing.
   */
  requestTag?: RequestTag;
}

export interface MetadataObject {
  eTag?: string;
}

export interface CustomHeaders {
  responseType?: string;
}

export interface IFetchDataResponse<T, E = any> {
  success: boolean;
  data?: T;
  /**
   * raw error
   */
  error?: APIError;
  /**
   * mapped error
   */
  appError?: AppError<E>;
  status?: number;
  metadata: MetadataObject;
  aborted?: boolean;
}

export interface GridResponseData<T, O = any> {
  total: number;
  items: T[];
  count?: number;
  options?: O;
}
